export default {"src":"/_next/static/media/undraw_savings.14c52c76.svg","height":597,"width":741,"blurWidth":0,"blurHeight":0};